// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"5d8b2bdb","368":"25515a1b","488":"b1a4a5cb","687":"22c18dcd","978":"d6c76560"}[chunkId] + ".chunk.js";
};